import { Badge } from "zudoku/ui/Badge.js";

const audienceLabels = {
	advertiser: "Advertiser",
	publisher: "Publisher",
} as const;

type AudienceBadgeProps = {
	audience?: string;
};

/** */
export default function AudienceBadge({ audience }: AudienceBadgeProps) {
	if(!audience || !(audience in audienceLabels)) { return null; }

	const label = audienceLabels[audience as keyof typeof audienceLabels];

	return (
		<Badge
			aria-label={`Audience: ${label}`}
			className={`audience-badge audience-badge-${audience}`}
			variant="outline"
		>
			{label}
		</Badge>
	);
}
